import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AppRoutes from './AppRoutes';
import './styles/global.css';

function App() {
  console.log('App component rendering'); 
  return (
    <Router>
      <Header />
      <main className="main-content">
        <AppRoutes />
      </main>
      <Footer />
    </Router>
  );
}

export default App;